// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"7cd8f945","399":"9ebd03bd"}[chunkId] + ".chunk.css";
};